export default {
  setGood(state, value) {
    state.good = value
  },
  setGoods(state, value) {
    state.goods = value
  },
  setGoodErrors(state, value) {
    state.goodErrors = value
  },
  setGoodField(state, obj) {
    if (state.good) {
      state.good[obj.key] = obj.value ? obj.value : null
    }
  },
  addGoodImage(state, image) {
    if (state.good) {
      state.good.images = [...state.good.images, image]
    }
  },
  delGoodImage(state, imageId) {
    if (state.good) {
      state.good.images = state.good.images.filter(image => image.id !== imageId)
    }
  },
  setGoodErrorsField(state, obj) {
    if (state.goodErrors) {
      state.goodErrors[obj.key] = obj.value
    }
  },
  setGoodFilters(state, value) {
    state.goodFilters = value
  },
  setGoodForm(state, value) {
    state.goodForm = value
  },
  changeGood(state, payload) {
    for (let i = 0; i < state.goods.length; i++) {
      if (state.goods[i].id === payload.key) {
        const item = _.cloneDeep(payload.value)
        state.goods.splice(i, 1, item)
        break
      }
    }
  },
  unshiftGoods(state, value) {
    state.goods.unshift(value)
  },
  deleteGood(state, id) {
    for (let i = 0; i < state.goods.length; i++) {
      if (state.goods[i].id === id) {
        state.goods.splice(i, 1)
        break
      }
    }
  },
  setGoodPriceActual(state, priceActual) {
    if (state.good.price_actual) {
      state.good.price_actual.price = priceActual
    } else {
      state.good.price_actual = {
        price: priceActual,
      }
    }
  },
}
